var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { requireToken } from '../../utility/general';
import { postRawJson } from '../../utility/request';
import Card from './card';
import CModal from './modal';
import CModalConfirm from './modal.confirm';
export default () => {
    var _a;
    const token = requireToken('merchant');
    const [showFileInput, setShowFileInput] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [isUploading, setIsUploading] = React.useState(false);
    const [uploadError, setUploadError] = React.useState('');
    const [importResults, setImportResults] = React.useState(null);
    const [confirmImport, setConfirmImport] = React.useState(false);
    React.useEffect(() => {
        if (!uploadError) {
            return;
        }
        const t = window.setTimeout(() => setUploadError(''), 25000);
        return () => window.clearTimeout(t);
    }, [uploadError]);
    React.useEffect(() => {
        if (!importResults) {
            return;
        }
        const t = window.setTimeout(() => setImportResults(null), 25000);
        return () => window.clearTimeout(t);
    }, [importResults]);
    const handleFileSelect = (e) => {
        var _a;
        const file = ((_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0]) || null;
        if (file && !(file.type === 'text/csv' || file.name.toLowerCase().endsWith('.csv'))) {
            setUploadError('Please select a CSV file');
            setSelectedFile(null);
            e.target.value = '';
            return;
        }
        setSelectedFile(file);
        setUploadError('');
    };
    const cancelUpload = () => {
        setShowFileInput(false);
        setSelectedFile(null);
        setUploadError('');
    };
    const submitImport = (finish) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (!selectedFile) {
                return;
            }
            setIsUploading(true);
            setUploadError('');
            const formData = new FormData();
            formData.append('file', selectedFile);
            yield postRawJson(`/merchants/${token.merchant.id}/clients/import`, formData, {
                'success': (result) => {
                    setImportResults(result);
                    if (result.successCount > 0) {
                        setShowFileInput(false);
                        setSelectedFile(null);
                    }
                    setConfirmImport(false);
                },
                'error': (response) => __awaiter(void 0, void 0, void 0, function* () {
                    throw new Error((yield response.text()) || 'Failed to import customers');
                }),
            });
        }
        catch (e) {
            setUploadError((e === null || e === void 0 ? void 0 : e.message) || 'Failed to import customers');
        }
        finally {
            setIsUploading(false);
            finish();
        }
    });
    const downloadTemplate = () => {
        const headers = [
            'FirstName', 'LastName', 'Address', 'City', 'State', 'Zip', 'Phone', 'Mobile', 'Email',
            'VehicleDescription', 'VehicleVin', 'VehicleTag', 'VehicleNotes',
        ];
        const sampleRow = [
            'John', 'Doe', '123 Main Street', 'Los Angeles', 'CA', '90001',
            '213-555-0123', '213-555-0124', 'john.doe@example.com',
            '2020 Toyota Camry', '1HGCM82633A123456', 'ABC123', 'Regular maintenance',
        ];
        const csv = `${headers.join(',')}\n${sampleRow.join(',')}`;
        const blob = new Blob([csv], { 'type': 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'customer_import_template.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    return _jsxs(_Fragment, { children: [_jsx(CModalConfirm, { title: "Confirm Import", action: "Import", visible: confirmImport, onClose: () => setConfirmImport(false), onSubmit: (f) => submitImport(f), children: "Are you sure you want to import this file? This will add new customers to your system." }), _jsx(CModal, { visible: !!importResults, onClose: () => setImportResults(null), title: "Import Results", nofooter: true, children: !!importResults && _jsxs("div", { children: [_jsxs("div", { className: `alert ${importResults.errorCount > 0 ? 'alert-warning' : 'alert-success'}`, children: [_jsx("p", { className: "mb-2", children: _jsx("strong", { children: "Import Complete" }) }), _jsxs("p", { children: ["Successfully imported: ", importResults.successCount, " customers"] }), _jsxs("p", { children: ["Failed to import: ", importResults.errorCount, " customers"] }), _jsxs("p", { children: ["Total processed: ", importResults.totalProcessed, " rows"] })] }), !!((_a = importResults.errors) === null || _a === void 0 ? void 0 : _a.length) && _jsxs("div", { className: "mt-3", children: [_jsx("h6", { children: "Errors:" }), _jsx("ul", { className: "text-danger", children: importResults.errors.map((error, i) => _jsx("li", { children: error }, `${i}-${error}`)) })] })] }) }), _jsx(Card, { title: "Import Customers", children: "Please contact us to discuss importing customers." })] });
};
